<template>
  <article ref="scrollBox" class="bus_list_wrap home">
    <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1);">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM">确认下单</div>
        <div class="myHeaderR textalignR"></div>
      </div>
    </header>
    <section class="pages_content hDetail">
      <!-- <Spin v-if="loading">
        <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
        <div class="colorprimary">加载中</div>
      </Spin>-->

      <div class="jianbianBg">
        <div
          style="padding:0.2rem 0.4rem; background: #FFFFFF;border-radius:0.1rem;margin-bottom:0.2rem;"
        >
          <div class="flexContainer orderDate">
            <div class="flexItem1">
              <div class="selectDateShowTitle">
                <span class="fontSize3 color2 fontWeightChang">
                  <i class="iconfont_new icon-rili color4"></i> 入住
                </span>
                <span class="selectDateShowCon bolderFont2 fontSize4 color2 fontWeightCu">08-18</span>
                <span class="fontSize3 colorprimary fontWeightChang">
                  修改
                  <i class="iconfont_new icon-xiangxia2"></i>
                </span>
              </div>
              <div class="selectDateShowTitle">
                <span class="fontSize3 color2 fontWeightChang">
                  <i class="iconfont_new icon-rili color4"></i> 离店
                </span>
                <span class="selectDateShowCon bolderFont2 fontSize4 color2 fontWeightCu">08-18</span>
                <span class="fontSize3 colorprimary fontWeightChang">
                  修改
                  <i class="iconfont_new icon-xiangxia2"></i>
                </span>
              </div>
            </div>
            <div style="padding-top:0.5rem;padding-left: 0.5rem;">
              <div class="selectDateMBlack textalignM">1晚</div>
            </div>
          </div>
          <div style="margin-top:0.3rem;">
            <div class="flexContainer">
              <div class="flexItem1">
                <div class="fontSize4 color2 fontWeightCu">特价房</div>
                <div class="fontSize3 color2 fontWeightChang">大床 55-60 有窗 可吸烟</div>
                <span class="goodItemTag">不可取消</span>
              </div>
              <div
                class="fontSize3 colorprimary"
                style="padding-top:0.1rem;"
                @click="detailModal=true"
              >
                房型详情
                <i class="iconfont_new icon-xiangyou"></i>
              </div>
            </div>
          </div>
        </div>

        <div style="padding:0.2rem 0.4rem; background: #FFFFFF;border-radius:0.1rem;">
          <div class="fontSize4 color2 fontWeightCu">订房必读</div>
          <div
            class="marginT2 lineheight4 fontSize3 color2 fontWeightChang"
          >订房必订房必读订房订房必订房必读订房必读订房必读订房必读读订房必订房必读订房必读订房必读订房必读读必读订房必读订房必读读</div>
        </div>
      </div>


      <div style="padding:0.2rem 0.2rem; background: #FFFFFF;border-radius:0.1rem;line-height: 0.6rem;" class="comfirm">
        <div class=" hangbanBox">
          <div class="flexContainer difangInput color4">
            <div style="width:2.5rem;">
              <i class="iconfont_new icon-jiudian2"></i> 房间数
            </div>
            <div class="flexItem1 textalignR">
              <select class="noBorderSelect" placeholder="请输入房间数" v-model="chufadi">
                <option :value="1">1间</option>
                <option :value="2">2间</option>
                <option :value="3">3间</option>
                <option :value="4">4间</option>
                <option :value="6">5间</option>
              </select>
            </div>
          </div>
          <div class="flexContainer difangInput color4">
            <div style="width:2.5rem;">
              <i class="iconfont_new icon-icon-"></i> 联系人
            </div>
            <div class="flexItem1 textalignR">
              <input type="text" class="noBorderInput" v-model="chufadi" placeholder="请输入联系人" />
            </div>
          </div>
          <div class="flexContainer difangInput color4">
            <div style="width:2.5rem;">
              <i class="iconfont_new icon-tel"></i> 手机号
            </div>
            <div class="flexItem1 textalignR">
              <input type="text" class="noBorderInput" v-model="mudidi" placeholder="请输入联系人手机号" />
            </div>
          </div>
          <div class="flexContainer difangInput color4">
            <div style="width:2.5rem;">
              <i class="iconfont_new icon-xuzhi"></i> 特殊要求
            </div>
            <div class="flexItem1 textalignR">
              <input type="text" class="noBorderInput" v-model="mudidi" placeholder="请输入特殊要求" />
            </div>
          </div>
        </div>
      </div>

      

      

      <Modal v-model="detailModal" class-name="myModalNoFooter" :closable="false">
        <div style="position:relative;">
          <swiper
            :swiperImgArray="advertList"
            :swiperWrapClass="swiperClass"
            style="position:relative;z-index:1;"
          ></swiper>
          <i
            class="iconfont_new icon-LC_icon_close_circle_line closeIcon"
            @click="detailModal = false"
          ></i>
        </div>

        <div style="padding:0.2rem 0.3rem;">
          支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。
          <br />
        </div>

        <div slot="footer">
          <div class="flexContainer myFooter">
            <div class="flexItem1">
              <div class="myFooterPrice textalignL">
                <span class="myFooterPriceIcon">¥</span>350
              </div>
            </div>
          </div>
        </div>
      </Modal>

      
    </section>


    <footer class="myFooter">
      <div class="flexContainer">
        <div class="flexItem1">
          <div class="myFooterPrice">
            <span class="myFooterPriceIcon">¥</span>350
          </div>
        </div>
        <div class="myFooterBtnDiv">
          <div class="myFooterBtn" @click="goNextPage()">去支付</div>
        </div>
      </div>
    </footer>

  </article>
</template>

<script>
import Swiper from "@/components/child-components/Swiper";
export default {
  name: "HotelOrderComfirm",
  components: { Swiper },
  data() {
    return {
      name: "", // 商户标识
      detailModal: false,

      advertList: ['https://dimg04.c-ctrip.com/images//200s0u000000j0f155AFB_C_750_400_Q50.jpg_.webp','https://dimg04.c-ctrip.com/images//200s0u000000j0f155AFB_C_750_400_Q50.jpg_.webp'],
      swiperClass: "big_banner_wrap",
    };
  },
  activated: function () {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
@import "../style/home.less";
.pages_title {
  background-color: transparent;
  padding: 0;
  color: #fff;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HotelOrderComfirm.vue